import { Grid, alpha, styled } from '@mui/material';
import { NavLink } from 'react-router-dom';

export const LogId = styled(NavLink)(({ theme }) => ({
  color: theme.palette.primary.main,
  cursor: 'pointer',
  textDecoration: 'underline',
  '&:hover': {
    textDecoration: 'underline',
    fontWeight: theme.typography.fontWeightBold
  }
}));

export const LogProperty = styled('pre')(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  borderRadius: '5px',
  paddingInline: theme.spacing(2),
  paddingBlock: theme.spacing(1),
  marginBlock: theme.spacing(1)
}));

export const LogPropertyContainer = styled(Grid)(({ theme }) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  '& strong': {
    paddingRight: theme.spacing(1)
  }
}));
